export const AUTH_CONSTANTS = {
  ACCESS_TOKEN: 'auth_token',
  REFRESH_TOKEN: 'auth_refresh_token',
};
